module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-row",
    class: [
      _vm.justify !== 'start' ? 'is-justify-' + _vm.justify : '',
      _vm.align !== 'top' ? 'is-align-' + _vm.align : '',
      {
        'el-row-flex': _vm.type === 'flex'
      }
    ],
    style: (_vm.style)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-e1a6aee6!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/row/src/row.vue
// module id = 684
// module chunks = 0